import { useApiStore } from '@/stores/apiStore';
import { UserStatusApi } from '@/../generated-client/apis/UserStatusApi';

let userStatusApi: UserStatusApi | null = null;
let lastConfig: unknown = null;

function getUserStatusApi(): UserStatusApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (userStatusApi === null || lastConfig !== apiConfig) {
    userStatusApi = new UserStatusApi(apiConfig);
    lastConfig = apiConfig;
  }

  return userStatusApi;
}
/**
 * Gets all group user statuses from the UserStatus/groups endpoint
 * @param {string} orgCode
 */
export const getAllGroupUserStatusesFromOrg = async (orgCode?: string) => {
  const api = getUserStatusApi();

  return await api.apiUserStatusGroupsGet({ orgCode });
};

/**
 * Gets a group's user statuses
 * @param {string} groupId - The ID of the group
 */
export const getGroupUserStatuses = async (groupId: string) => {
  const api = getUserStatusApi();

  return await api.apiUserStatusGroupsGroupNameGet({ groupName: groupId });
};
